export default "__VITE_ASSET__CPpe0Gze__"